<ng-container *transloco="let t">
  <div class="dropzone-wrapper" [ngClass]="{'h-100': isFullHeight}">
    <div class="dropzone" [ngClass]="{'disabled': isDisabled, 'h-100': isFullHeight}">
      @if (!selectedFile) {
        <div class="edit-btn-wrapper">
          <button class="btn shadow btn-circle red-btn">
            <i class="fas fa-pen"></i>
          </button>
        </div>
      }
      @if (!isDisabled) {
        <div class="input-holder">
          @if (useWithCropper) {
            <div (click)="openImageCropper()" class="cropper-tap-area"></div>
          } @else {
            @if (!this.useWithCropper) {
              <input type="file" class="form-control" [accept]="accept()" #file (change)="processFile(file)">
            }
          }
        </div>
      }
      @if (!!selectedFile) {
        <div>
          @if (fileType === FileType.IMAGE) {
            <div class="image-preview-holder">
              <img [src]="selectedFile" class="image-preview">
            </div>
          }
          @if (fileType === FileType.XLS) {
            <div>
              <div class="centered">
                <div>
                  <div class="d-flex justify-content-center align-items-center pb-3">
                    <i class='fas fa-file-excel icon-file'></i>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <span>{{ fileName }}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (selectedFile && !isDisabled) {
        <div class="input-hover">
          <div class="input-overlay">
            @if (fileType === FileType.IMAGE) {
              <div class="centered">
                <div>
                  <i class="bi bi-cloud-arrow-up-fill fs-3"></i>
                  <p class="file-upload-default-message">
                    {{ getUploadText() }}
                  </p>
                </div>
              </div>
            }
          </div>
          <div class="delete-button">
            <button (click)="onDeleteFile()" class="btn shadow btn-circle red-btn">
              <i class="fas fa-sm fa-x"></i>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
